/**
 * Menu script
 */
class PP_Menu {
    constructor() {
        this.initState();
        this.initEvents();
        this.initRWD();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menu = this.menuWrapper.find('#site-navigation');
        this.menuItemSubmenu = this.menuWrapper.find('.menu-item-has-children');
        this.mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
        this.desktopViewport = window.matchMedia("screen and (min-width: 1025px)");
        this.searchBtn = this.menuWrapper.find('.menu-search-btn');
        this.menuLinks = $('#menu-main a');
    }

    initEvents() {
        this.menuItemSubmenu.append( "<span class='arrow'></span>" );

        $(window).on('scroll', () => {
            let positionY = this.win.scrollTop();

            if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.addClass('is-fixed');
                return;
            }

            if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.removeClass('is-fixed');
            }
        });

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                this.menu.toggleClass('is-active');
                this.menuIcon.toggleClass('is-active');
                $(document.body).toggleClass('no-scroll');

                setTimeout(() => {
                    this.menu.toggleClass('is-showing');
                }, 150);
            });

            this.menuLinks.on('click', e => {
                if ($(window).width() <= 1024) {
                    this.menuIcon.trigger('click');
                }
            });
        }
    }

    initRWD () {
        if(this.mobileViewport.matches) {
            this.initMobileViewportBehaviour();
        }

        if(this.desktopViewport.matches) {
            this.initDesktopViewportBehaviour();
        }

        this.mobileViewport.addListener(mq => {
            if (mq.matches) {
                this.initMobileViewportBehaviour();
            }
        });

        this.desktopViewport.addListener(mq => {
            if (mq.matches) {
                this.initDesktopViewportBehaviour()
            }
        });
    }

    initMobileViewportBehaviour () {
        setTimeout(() => {
            this.menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');

            this.menuSubmenuToggle.each(function(i, item) {
                $(item).on('click', (e) => {
                    $(item).parent().toggleClass('is-active');
                });
            });

            this.searchBtn.insertBefore(this.menuIcon);
        }, 0);
    }

    initDesktopViewportBehaviour () {
        setTimeout(() => {
            this.searchBtn.insertBefore(this.menuWrapper.find('.menu-additional-cta'));
        }, 0);
    }
}
